var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    style: {
      fill: "#fff"
    },
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75,24.5l0.06,0.06a0.69,0.69,0,0,1,.13.16,0.12,0.12,0,0,0,0,.09,0.69,0.69,0,0,1,0,.25v0.22a1,1,0,0,1-.25.47l-4,4a0.56,0.56,0,0,1-.22.16,0.84,0.84,0,0,1-.47.09,0.69,0.69,0,0,1-.25,0l-0.06-.06a0.36,0.36,0,0,1-.19-0.09L16,21.25,7.44,29.81a0.27,0.27,0,0,1-.16.09L7.19,30a0.69,0.69,0,0,1-.25,0,0.47,0.47,0,0,1-.22,0,0.73,0.73,0,0,1-.47-0.22l-4-4a0.56,0.56,0,0,1-.16-0.22A0.84,0.84,0,0,1,2,25.06a0.69,0.69,0,0,1,0-.25l0.06-.09a0.26,0.26,0,0,1,.09-0.16L10.75,16,2.19,7.44s0-.06-0.06-0.09a0.55,0.55,0,0,1-.06-0.16A0.74,0.74,0,0,1,2,6.94a0.69,0.69,0,0,1,0-.25,0.73,0.73,0,0,1,.22-0.44l4-4a0.56,0.56,0,0,1,.22-0.16A0.84,0.84,0,0,1,6.93,2a0.72,0.72,0,0,1,.25.06H7.28a0.66,0.66,0,0,1,.16.13L16,10.75l8.56-8.56a1,1,0,0,1,.19-0.12,0.06,0.06,0,0,0,.06,0,0.69,0.69,0,0,1,.25,0h0.25a1,1,0,0,1,.44.25l4,4a0.56,0.56,0,0,1,.16.22,0.84,0.84,0,0,1,.09.47,0.69,0.69,0,0,1,0,.25,0.06,0.06,0,0,0,0,.06l-0.12.19L21.25,16Z",
    transform: "translate(-2 -2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.222ba5bc67f1ea68eaa0252f8d4dbe39.svg";
export { ForwardRef as ReactComponent };